// DepositEmptyState.tsx
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const Container = styled('div')(({ theme }) => ({
	display: 'grid',
	placeItems: 'center',
	minHeight: 320,
	height: '100%',
	width: '100%',
	position: 'relative',
	backgroundColor: '#fff',
	borderRadius: 20,
	border: `1px solid  ${theme.palette.divider}`,
}));

const Root = styled('div')(({ theme }) => ({
	display: 'grid',
	placeItems: 'center',
	minHeight: 320,
	width: '100%',
}));

const Panel = styled(Box)(({ theme }) => ({
	textAlign: 'center',
	display: 'flex',
	flexDirection: 'column',
	padding: theme.spacing(5),
}));

const Title = styled(Typography)(({ theme }) => ({
	fontWeight: 600,
	margin: 0,
}));

const Subtitle = styled(Typography)(({ theme }) => ({
	marginTop: theme.spacing(1),
	color: theme.palette.text.secondary,
}));

export const DepositEmptyState: React.FC = () => {
	return (
		<Container>
			<Root role="status" aria-live="polite">
				<Panel>
					<Title variant="subtitle2">Make a deposit first</Title>
					<Subtitle variant="caption">
						Start with simple vault deposits before exploring
						leverage
					</Subtitle>
				</Panel>
			</Root>
		</Container>
	);
};

export default DepositEmptyState;
